<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative"> 
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">

      <vs-row vs-w="12">

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" >
            <img src="@/assets/images/logo/kanan.jpg" alt="Logo" WIDTH="180" HEIGHT="65">
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12">
            <div class="vx-col md:w-3/6 sm:w-1/2 w-full">
              <p class="text-2xl font-semibold" style="color: black" ALIGN="center"> {{ fechActual }} </p>
              <p class="text-2xl font-semibold" style="color: black"  ALIGN="center"> {{ horaActual }} </p>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <img :src="`http://w.administraflotilla.com/images/imagesempresa/${this.imgg}`" WIDTH="180" HEIGHT="50" />
          </vs-col>

        </vs-row>

    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import Logo                 from "../Logo.vue"
import authConfig           from '@/../auth_config.json'
import Axios                from "axios"

export default {
  data(){
    return{
      imgg: 'default.png',
          // Reloj
            fechActual: "",
            horaActual: "",
    }
  },
  name: "the-navbar-horizontal",
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    navbarColor() {
      let color = "#FFC000"
      if (this.navbarType === "sticky") color = "#f7f7f7"
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = "#f7f7f7"
        }
      }

      this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

      return color
    },
    isThemedark()          { return this.$store.state.theme                                                                       },
    navbarStyle()          { return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}                      },
    navbarClasses()        { return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none" },
    scrollY()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth()          { return this.$store.state.windowWidth                                                                 },
  },
  mounted() {
    setInterval(() => {
      let data = new Date(),
      horas = data.getHours() < 10 ? '0' + data.getHours() : data.getHours(),
      minutos = data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes(),
      segs = data.getSeconds() < 10 ? '0' + data.getSeconds() : data.getSeconds(),
      diaSemana = data.getDay(),
      dia = data.getDate() < 10 ? '0'+ data.getDate() : data.getDate(),
      mes = data.getMonth(),
      year = data.getFullYear();

      let semana = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
      let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      this.fechActual = `${semana[diaSemana]}, ${dia} de ${meses[mes]} del ${year}`
      this.horaActual = `${horas} : ${minutos} : ${segs}`
    }, 1000);
  },
  created() {
    if(authConfig.EmpresaId != undefined){
      Axios.get(`${this.WS }/Dashboard/GetImgByEmpresaID/${authConfig.EmpresaId}`)
      .then(response => {
        if (response.data.Nombre != null)
          this.imgg = response.data.Nombre
      })
    }
  },
}

</script>

